import store from '../store/store';

let sequence = 1;

export function showPendingRequest(message) {
	var handle = sequence++;
	store.dispatch({
		type: 'pendingRequests.showPendingRequest',
		request: {
			handle,
			message
		}
	});
	return handle;
}

export function hidePendingRequest(handle) {
	if (handle === null) {
		return;
	}
	store.dispatch({
		type: 'pendingRequests.hidePendingRequest',
		handle
	});
}

export function setPendingRequestMessage(handle, message) {
	store.dispatch({
		type: 'pendingRequests.setMessage',
		handle,
		message
	});
}


export async function showMessageBox(message, options) {
	var handle = sequence++;
	options = options || {};
	let _resolve;
	const res = new Promise(function(resolve) {
		_resolve = resolve;
	});
	const callback = function(res) {
		store.dispatch({
			type: 'messageBox.hideMessageBox',
			handle
		});
		_resolve(res);
	}
	store.dispatch({
		type: 'messageBox.showMessageBox',
		request: {
			handle,
			message,
			options,
			callback
		}
	});
	return res;
}

